// Unpublished Work © 2025 Deere & Company.

import {Query} from '@tanstack/react-query';
import {businessActivityError} from '../../BusinessActivity/error';
import {chemicalsError} from '../../Chemical/error';
import {connectedApplicationError} from '../../ConnectedApplication/error';
import {cropsError} from '../../Crop/error';
import {cropPredictionsError} from '../../CropPrediction/error';
import {dryBlendsError} from '../../DryBlends/error';
import {boundariesError, fieldsError, hasFieldsError} from '../../Field/error';
import {fieldOperationError} from '../../FieldOperation/error';
import {fileError} from '../../File/error';
import {equipmentError} from '../../Implement/error';
import {licenseAssignmentsError} from '../../LicenseAssignments/error';
import {operatorError} from '../../Operator/error';
import {orgPreferencesError} from '../../OrgPreferences/error';
import {partnerOrganizationsError} from '../../PartnerOrganizations/error';
import {
    predictiveFeedRateError,
    predictiveFeedRateOrgPreferencesError,
} from '../../PredictiveFeedRate/error';
import {productTotalsError} from '../../ProductTotals/error';
import {prescriptionMetaError, rxError} from '../../Rx/error';
import {tankMixesError} from '../../TankMix/error';
import {ToastType} from '../../Toast/models/toast';
import {toggleError} from '../../Toggle/error';
import {varietiesError} from '../../Variety/error';
import {varietyLocatorError} from '../../VarietyLocator/error';
import {vrDomainError} from '../../VrDomain/error';
import {workPlansError} from '../../WebInputs/error';
import {translationsError} from '../error';
import {handleError} from './handleError';

export interface ErrorHandlerConfig {
    customAction?: (error: Error, query: Query) => void;
}

export const getErrorMessageToastType = (
    error: Error,
    message: string,
): ToastType => {
    return {
        message,
        variant: 'error',
        occurredError: error,
    };
};

export const commonErrorAction = (error: Error, query: any) => {
    if (error && error.name !== 'AbortError') {
        handleError(error, query);
    }
};

export const errorMessages: Record<string, ErrorHandlerConfig> = {
    webInputs: workPlansError,
    Translations: translationsError,
    BusinessActivities: businessActivityError,
    AxiomChemicals: chemicalsError,
    AxiomConnectedApplications: connectedApplicationError,
    AxiomCrops: cropsError,
    AxiomCropPredictions: cropPredictionsError,
    AxiomDryBlends: dryBlendsError,
    AxiomLicenseAssignments: licenseAssignmentsError,
    AxiomBoundaries: boundariesError,
    AxiomFields: fieldsError,
    hasFields: hasFieldsError,
    AxiomFieldOperation: fieldOperationError,
    AxiomFiles: fileError,
    AxiomEquipment: equipmentError,
    AxiomOperators: operatorError,
    AxiomOrgPreferences: orgPreferencesError,
    AxiomPartnerOrganizations: partnerOrganizationsError,
    PredictiveFeedRate: predictiveFeedRateError,
    PredictiveFeedRateOrg: predictiveFeedRateOrgPreferencesError,
    ProductTotals: productTotalsError,
    prescriptionMeta: prescriptionMetaError,
    Rx: rxError,
    geoJsonByRxAndLayerId: rxError,
    AxiomTankMixes: tankMixesError,
    AxiomToggles: toggleError,
    AxiomVarieties: varietiesError,
    AxiomVrDomains: vrDomainError,
    varietyLocator: varietyLocatorError,
    VarietyLocatorByField: varietyLocatorError,
};
